import { render, staticRenderFns } from "./FragmentOgEmbed.vue?vue&type=template&id=427aed3c&scoped=true"
import script from "./FragmentOgEmbed.vue?vue&type=script&lang=ts"
export * from "./FragmentOgEmbed.vue?vue&type=script&lang=ts"
import style0 from "./FragmentOgEmbed.vue?vue&type=style&index=0&id=427aed3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427aed3c",
  null
  
)

export default component.exports